import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { Col, Table, Row, Divider } from 'antd';
import { ExcelIcon } from 'icons';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useLogs from '../useLogs';

const MainPage = () => {
  const {
    data,
    columns,
    filters,
    onChangeTableFilter,
    loading,
    handleDownloadExcel,
  } = useLogs();
  const { t } = useTranslation();

  return (
    <>
      <PageHeader title={t('LOGS').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
            >
              {t('Export')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <Divider />
        <Table
          columns={columns}
          dataSource={data.retailLcademyLogs}
          pagination={data.pagination}
          scroll={{ x: 1500 }}
          onChange={onChangeTableFilter}
          loading={loading}
        />
      </div>
    </>
  );
};

export default MainPage;
